export default __webpack_public_path__ + "static/media/pasouno.fdd1c808.png";